var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    transform: "rotate(18)",
    viewBox: "0 0 24 24",
    className: "_dm-svg",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.516 8.016c4.641 0 8.531 3.047 9.938 7.219l-2.344.75a7.953 7.953 0 00-7.594-5.484c-1.969 0-3.75.703-5.156 1.875l3.656 3.609h-9v-9l3.563 3.609a10.542 10.542 0 016.938-2.578z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoArrow);
export default __webpack_public_path__ + "static/media/UndoArrow.da5061690541f877cce60983d560a32d.svg";
export { ForwardRef as ReactComponent };